export default function checkedKeysCompare(initKeys, newKeys) {
  const initKeysFmt = initKeys.sort();
  const newKeysFmt = newKeys.sort();

  return JSON.stringify(initKeysFmt) === JSON.stringify(newKeysFmt);
}
